module.exports = __webpack_public_path__ + "media/stylesheets/images/toppage/top-mv-920aa533bcc60ebd7e87ca6f0a977c7c.mp4";